module.exports = __webpack_public_path__ + "static/media/SLIDERS-BIO-600.50247186.png";